import { render } from "./VSearch.vue?vue&type=template&id=3a5bb908&scoped=true"
import script from "./VSearch.vue?vue&type=script&lang=js"
export * from "./VSearch.vue?vue&type=script&lang=js"

import "./VSearch.vue?vue&type=style&index=0&id=3a5bb908&lang=scss&scoped=true"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5bb908"]])

export default __exports__